import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { ILogging } from 'shared/src/api/types/ILogging';

type LogClickMarketParams = {
  logging: ILogging;
};

export const useLogClickMarket = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ logging }: LogClickMarketParams) => {
      logAnalyticsEvent({
        name: 'CLICK_MARKET',
        analytics: {
          POSITION: null,
          ...logging.analytics,
        },
        ably_only_log: logging.ably_only_log,
      });
    },
    [logAnalyticsEvent],
  );
};
